import { deleteLaborCostCalc } from "@erp/shared/api/generated/wrappers/backdata";
import { patchLaborCostCalc, } from "@erp/shared/api/generated/wrappers/backdata";
import { postLaborCostCalc, } from "@erp/shared/api/generated/wrappers/backdata";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
export const useLaborCostCalcAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const readQuery = useQuery(queries.laborCost.laborCostCalc());
    const createMutation = useMutation({
        mutationFn: async (body) => await postLaborCostCalc(body),
        onSuccess: () => {
            showAlert("노무비 산출 정보 등록 완료", "완료");
            invalidateQueries([queries.laborCost.laborCostCalc().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "노무비 산출 정보 등록 실패");
        },
    });
    const updateMutation = useMutation({
        mutationFn: async ({ id, body, }) => await patchLaborCostCalc(id, body),
        onSuccess: () => {
            showAlert("노무비 산출 정보 수정 완료", "완료");
            invalidateQueries([queries.laborCost.laborCostCalc().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "노무비 산출 정보 수정 실패");
        },
    });
    const deleteMutation = useMutation({
        mutationFn: async (id) => await deleteLaborCostCalc(id),
        onSuccess: () => {
            showAlert("노무비 산출 정보 삭제 완료", "완료");
            invalidateQueries([queries.laborCost.laborCostCalc().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "노무비 산출 정보 삭제 실패");
        },
    });
    return {
        readQuery,
        createMutation,
        updateMutation,
        deleteMutation,
    };
};
